import styled from '@emotion/styled';

export const FormContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4.4rem;
	max-width: 44rem;
	width: 100%;
	margin: 0 auto;
	@media screen and (max-width: ${(props) => props.theme.breakpoints.layout}px) {
		padding: 0 2rem;
	}
`;
export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
`;
export const Title = styled.h2`
	color: #212529;
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
`;
export const FormGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;
export const Label = styled.label`
	font-size: 1.4rem;
	color: #212529;
	font-weight: 700;
	display: flex;
	align-items: center;
	line-height: 130%;
	letter-spacing: -0.6px;
`;
export const CertState = styled.p`
	font-weight: 400;
	font-size: 1.6rem;
	line-height: 100%;
	letter-spacing: -0.6px;
	&.normal {
		color: #16a34a;
	}
	&.error {
		color: #dc2626;
	}
`;
export const EditButton = styled.button`
	background-color: transparent;
	color: #212529;
	height: 4.4rem;
	padding: 0 1.2rem;
	border: none;
	cursor: pointer;
	border: 1px solid #212529;
	&:disabled {
		border: 1px solid #adb5bd;
		color: #adb5bd;
		cursor: auto;
	}
`;
